$(document).ready(function() {
// ***** Index banner Slider ***** //
 
jQuery('.slider_primary_main .slider_primary').marquee({
  duration: 20000,
  pauseOnHover: false,
  gap: 0,
  duplicated: true,
  startVisible: true,
  direction: 'up', 
});

jQuery('.slider_primary_reverse').marquee({
  duration: 20000,
  pauseOnHover: false,
  gap: 0,
  duplicated: true,
  startVisible: true,
  direction: 'down',
});

// ***** end banner Slider ***** //
  
// ***** homepage marque ***** //




if ($(window).width() < 767) {
  $(".inline-marquee").marquee({
  duration: 20000, 
  gap: 40,
  delayBeforeStart: 0,
  direction: "left", 
  duplicated: true,
  startVisible: true,
  pauseOnHover: true
 
});

}
else {
  $(".inline-marquee").marquee({
  duration: 50000, 
  gap: 40,
  delayBeforeStart: 0,
  direction: "left", 
  duplicated: true,
  startVisible: true,
  pauseOnHover: true
 
});
}


// ****** end homepage marque ***** //

// ***** image with text slider ***** //
jQuery('.custom-text-with-image-slider .image-with-text__media-item').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  responsive: [
  {
    breakpoint: 768,
    settings: {
      arrows: false,
      dots: true,
    }
  }
]
});

//**** end image with text slider *****//
   
//***** scroll button ******//
$('.custom-multicolumn-2 .multicolumn-card .media img').attr('loading', '');
var target = $('.custom-index #custom_plan_header');

$('.custom-index .button').on('click', function(event) {
  if (target.length) {
    event.preventDefault();
    var headerHeight = $('header').outerHeight() || 100;
    var targetOffset = target.offset().top - headerHeight;
    console.log(targetOffset, 'targetOffset')
    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  }
});

// challenge page
let target_section = $('.custom-challege-waitlist .image-with-form-block');
$('.custom-challege-waitlist .challege_waitlist_results .section_button a').on('click', function(event) {
  if (target_section.length) {
    event.preventDefault();
    var headerHeight = $('header').outerHeight() || 100;
    var targetOffset = target_section.offset().top - headerHeight;
    // console.log(targetOffset, 'targetOffset')
    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  }
});
let target_section2 = $('.custom-challege-waitlist .form-checklist-grid');
$('.custom-challege-waitlist .challenge-banner-wrapper  .banner-btn a').on('click', function(event) {
  if (target_section2.length) {
    event.preventDefault();
    var headerHeight = $('header').outerHeight() || 100;
    var targetOffset = target_section2.offset().top - headerHeight;
    // console.log(targetOffset, 'targetOffset')
    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  }
});
let target_section3 = $('.subscription_plan_section');
$('.custom-challenge-landing-page .belly_image_text_section .button,.custom-challenge-landing-page .custom-plan-list-slider-sec .button ,.custom-challenge-landing-page .counter-bar-btn .button').on('click', function(event) {
  if (target_section3.length) {
    event.preventDefault();
    var headerHeight = $('.custom-sticky-count-bar').outerHeight() || 100;
    var targetOffset = target_section3.offset().top - headerHeight;
    // console.log(targetOffset, 'targetOffset')
    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  }
});

 
//***** end scroll button ******//

  
   
//***** product page add to cart trigger *****//
   
$('.about_product_section .image-with-text__text-item .button').click(function(e){
  e.preventDefault();
  let info = $(this).closest('main').find('product-info .product .product__info-wrapper .product-form .product-form__buttons .product-form__submit');
  $(info).trigger('click');
})

// ******* end product page add to cart trigger *****//


// ****** home page image slider *** //
$('.custom-img-slider-one .three-image-slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1.5,
        dots: false
      } 
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});

// $('.custom-blood-landing-slider .three-image-slider').slick({
//   dots: true,
//   arrows: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1.5,
//         slidesToScroll: 1.5,
//         dots: false
//       } 
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
  
//   ]
// });
//  **** end image slider ****//

// product page image slider
  
$('.custom-img-slider-two .three-image-slider').slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      } 
    }
 
  ]
});
// end of product page image slider

// ********** collection page js  *********** //


  $(document).ready(function () {
   // ================== Collection Progress Loader ==================
    function collection_loader() {
      let item_count = $('#product-grid li').length;
      $('.left_count').text(item_count);

      let total_items = $('.collection_progress_bar').data('total-count');
      if (item_count < total_items) {
        let width_count = (item_count / total_items) * 100;
        $('.inner_bar').css('width', `${width_count}%`);
      } else {
        $('.inner_bar').css('width', `100%`);
      }
    }

    collection_loader();

    // ================== Load More Button ==================
    $(document).on('click', '.load-more-btn', function () {
      let $btn = $(this);
      let $productsWrapper = $('#product-grid');
      let nextUrl = $productsWrapper.attr('data-next-url');
      if (!nextUrl) return;

      $btn.hide();

      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function (response) {
          let $nextPageHtml = $('<div>').html(response);
          let $newItems = $nextPageHtml.find('#product-grid > li');
          let newNextUrl = $nextPageHtml.find('#product-grid').attr('data-next-url');

          $productsWrapper.append($newItems);

          if (newNextUrl) {
            $productsWrapper.attr('data-next-url', newNextUrl);
            $btn.show();
          } else {
            $btn.remove(); // No more pages
          }
         collection_loader(); // Update progress
        },
        error: function () {
          $btn.show();
        }
      });
    });

    // ================== Filter Tab Click (Preserve Sorting) ==================
    $('.filter-tab').on('click', function (e) {
      e.preventDefault();

      const paramName = $(this).data('param-name');
      const paramValue = $(this).data('param-value');

      // Preserve all current query params
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set(paramName, paramValue);

      const newSearchParams = currentParams.toString();
      const newUrl = `${window.location.pathname}?${newSearchParams}`;

      // Update UI tab state
      $('.filter-tab').removeClass('active');
      $(this).addClass('active');

      // Push to browser history
      history.pushState({ searchParams: newSearchParams }, '', newUrl);

      // Trigger re-render with filters and sorting
      FacetFiltersForm.renderPage(newSearchParams, null, true);
    });

    // ================== Mark Active Tab on Page Load ==================
    const urlParams = new URLSearchParams(window.location.search);
    $('.filter-tab').each(function () {
      const paramName = $(this).data('param-name');
      const paramValue = $(this).data('param-value');
      if (urlParams.get(paramName) === paramValue) {
        $(this).addClass('active');
      }
    });

    // ================== Recalculate Loader After Product Grid Update ==================
    document.addEventListener('collection:updated', function () {
      collection_loader();
    });
  });
// Fix sorting to preserve filters
$(document).on('change', '#FacetFiltersForm select[name="sort_by"]', function (e) {
  const sortValue = $(this).val();
  const currentParams = new URLSearchParams(window.location.search);

  // Update or add sort_by to current filters
  currentParams.set('sort_by', sortValue);

  const newSearchParams = currentParams.toString();

  // Update URL and render new filtered + sorted products
  history.pushState({ searchParams: newSearchParams }, '', `${window.location.pathname}?${newSearchParams}`);
  FacetFiltersForm.renderPage(newSearchParams, null, true);
});

$(document).on('submit', '#FacetFiltersForm', function (e) {
  e.preventDefault();
});

  setTimeout(function(){
    jQuery('.custom-marquee-sec').addClass('visible');
  }, 1200);

});

function cartCollapse(){
  $(document).on('click','.cart_container .custom_addons_container h3', function(){
    $(this).siblings('.custom_addons_items').slideToggle().toggleClass('featured-products-hidden');
    $(this).toggleClass('arrow-down');
  })
}

// $(window).on('resize', function(){
//   if($(window).width() < 992){
//     cartCollapse();
//   }
// });
$(window).on('load', function(){
  // if($(window).width() < 992){
    cartCollapse();
  // }

});
// $(document).ready(function(){
//   $('.cart_container .custom_addons_items').addClass('featured-products-hidden');
//   $('.cart_container .custom_addons_container .addon_heading').addClass('arrow-down');
// })
//drawer continue btn 
  $(document).on('click','.custom-continue-btn a',function(e){
     e.preventDefault();
     let close_btn =  $(this).closest('.drawer__inner').find('.drawer__close');
     close_btn.trigger('click');
});

$('.image-with-form-block .form-submission-box .icon-close').each(function(){
  $(this).on('click', function(){
    $(this).parents('.image-with-form-block .form-submission-box').remove();
    $('.image-with-form-block .form-checklist-box').removeClass('hide'); 
  })
})


// **** Custom plan list slider

  $('.custom-plan-slider-sec .custom-plan-slider').slick({
    rows: 2,
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('.custom-plan-slider-buttons .slick-prev'),
    nextArrow: $('.custom-plan-slider-buttons .slick-next'),
      
  });

   $('.custom-plan-slider-sec.layout-2 .fixed-box-child-slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    // asNavFor: ".fixed-box-slider",
    draggable: false, 
    swipe: false,    
    touchMove: false
    // prevArrow: $('.custom-plan-slider-buttons .slick-prev'),
    // nextArrow: $('.custom-plan-slider-buttons .slick-next'),
      
  });

  $('.custom-plan-slider-sec.layout-2 .fixed-box-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".fixed-box-child-slider",
    prevArrow: $('.fixed-box-slider-arrows.controls-desktop .arrow-left'),
    nextArrow: $('.fixed-box-slider-arrows.controls-desktop .arrow-right'),
    responsive: [
      {
        breakpoint: 840,
        settings: {
          prevArrow: $('.fixed-box-slider-arrows.controls-mobile .arrow-left'),
          nextArrow: $('.fixed-box-slider-arrows.controls-mobile .arrow-right'),
        }
      },
    ]
  });

  
  $('.custom-plan-slider-sec.layout-2 .fixed-box-child-slider .item-grid-row.mobile-layout').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    // asNavFor: ".fixed-box-child-slider",
    // prevArrow: $('.fixed-box-slider-arrows.controls-desktop .arrow-left'),
    // nextArrow: $('.fixed-box-slider-arrows.controls-desktop .arrow-right'),
      
  });


  $('.bloodwork-grid-slider').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
      
  });

  $('.before-after-flip-slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        }
      }
    ]
      
  });

  $('.blood-list-slider-wrapper .block-btn .button').on('click', function(e){
    e.preventDefault();
    $(this).parents('.block-btn').siblings('.pdf-modal').attr('open', true);
  })
  $('.pdf-modal .btn-close').on('click', function(){
    $(this).parents('.pdf-modal').attr('open', false);
  })
  $('.pdf-modal .overlay').on('click', function(){
    $(this).parents('.pdf-modal').attr('open', false);
  });

  $('.fixed-box-slider .btn-box .button').on('click', function(e){
    e.preventDefault();
    var pdfFile = $(this).parents('.btn-box').attr('data-pdf');
    $(this).parents('.custom-plan-list-slider-sec.layout-2').find('.pdf-modal .pdf-viewer iframe').attr('src', pdfFile);
    $(this).parents('.custom-plan-list-slider-sec.layout-2').find('.pdf-modal').attr('open', true);
  })
  $('.custom-plan-list-slider-sec.layout-2 .pdf-modal .btn-close').on('click', function(){
    $(this).parents('.pdf-modal').find('iframe').attr('src', '');
  })

// $('.custom-plan-slider-sec .custom-plan-slider').on('afterChange', function(event, slick, currentSlide) {
//   console.log(slick, currentSlide);
//   if (slick.$slides.length-1 == currentSlide) {
//     console.log("Last slide");
//   }
// })
$('.custom-plan-slider-sec .custom-plan-slider').on('afterChange', function(event, slick, currentSlide) {
      if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
        // alert("Last slide!!!");
        $(this).siblings('.sliders-arrow-right-btn').addClass('hidden');
      }else{
         $(this).siblings('.sliders-arrow-right-btn').removeClass('hidden');
      }
});

// see more on challenge page *****************


$(document).ready(function () {
   $('.mobile-cards-design-box .custom-plan-list-slider .item').hide();
    $('.mobile-cards-design-box .custom-plan-list-slider .item').slice(0, 4).show();
     $('.see-more-btn-box').click(function(event) {
       event.preventDefault();
      $('.mobile-cards-design-box .custom-plan-list-slider .item').show(); 
      $(this).hide();               
    });

    $(".custom-blood-mulitcolumn .multicolumn-card__info .inline-richtext a").click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#blood_plan_section").offset().top
        }, 2000);
    });
});

// end see more ***************************

// **** sliding text ****


jQuery('.sliding-items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
  rtl:false,
});


// **** end of sliding text

document.addEventListener('DOMContentLoaded', () => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (platform.includes('mac') || /iphone|ipad|ipod/.test(userAgent)) {
    document.body.classList.add('device-ios');
  } 
  // else if (/iphone|ipad|ipod/.test(userAgent)) {
  //   document.body.classList.add('ios');
  // }
});

jQuery(document).ready(function(){
  setTimeout(function(){
    jQuery('.counter-header .countdown').addClass('visible');
  }, 1000)

  $('.slide-item .slide-box').click(function(){
    $(this).toggleClass('active_box');
  })
  $(".cta-Btn a , .custom-banner-bloodwork a").click(function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(".blood-plan-section").offset().top
    }, 2000);
 });

$('.cstm_home_banner_img_txt .image-with-text__content .button').click(function(e){
    e.preventDefault();
    console.log('click');
    jQuery('html').animate({
      scrollTop: jQuery(".custom_home_support_section").offset().top
    });
});
$('.custom_coach_block .multicolumn-card__info a.link').click(function(e){
    e.preventDefault();
    console.log('click');
    jQuery('html').animate({
    scrollTop: jQuery(".custom_home_select_plan").offset().top
});
})
$('.custom-challenge-landing-page-v2  a.button').click(function(e){
    e.preventDefault();
    console.log('click');
    jQuery('html').animate({
    scrollTop: jQuery("#select-plan").offset().top
});
})

if ($(window).width() < 767) {
   $('.custom_challenge_v2_select_plan .product__accordion details').removeAttr('open');
}


})
